import { Component, OnInit } from '@angular/core';
import { NavigationLocation, NextPageService } from '@cvx/nextpage';
import { MenuModule } from './shared/module/menu.module';
import { RouterOutlet } from '@angular/router';
import { MaterialModule } from './shared/module/material.module';
import { CommonModule } from '@angular/common';
import { CalAngularService } from '@cvx/cal-angular';
import { RoleService } from '../app/shared/services/RoleService';
import { CustomErrorPageComponent } from './shared/component/custom-error-page/custom-error-page.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [MenuModule, RouterOutlet, MaterialModule, CommonModule, CustomErrorPageComponent],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  isLoading: boolean = true;
  loggedUsername: string = '';
  loggedUserEmail: string = '';
  loggedUserCai: string = '';
  jobTitle: string = '';
  userType: string[] = [];
  loggedinAvailable: boolean = false;

  constructor(
    private NP: NextPageService,
    private authService: CalAngularService,
    private roleService: RoleService
  ) {
    this.NP.options.sitename = 'NMA DOA';
  }

  NavigationLocation = NavigationLocation;

  ngOnInit() {
    if (this.authService.isUserSignedIn()) {
      this.loggedUsername = this.authService.cvxClaimsPrincipal.name ?? '';
      this.loggedUserEmail = this.authService.cvxClaimsPrincipal.userName ?? '';
      this.loggedUserCai = '';
      this.filterMenuItems();
    } else {
      console.log('USER NOT LOGGED IN');
      this.isLoading = false;

    }
  }

  filterMenuItems(): void {
    this.roleService.fetchUserRoles().subscribe(
      (roles: string[]) => {
        this.userType = roles.map(role => role.trim()).filter(role => role.length > 0);
        this.loggedinAvailable = this.userType.length > 0;
        this.NP.options.navigationRoutes =
          this.NP.options.navigationRoutes.filter((route) => {
            const requiredRoles = route.data?.['expectedRoles'];
            if (!requiredRoles) {
              return true;
            }
            else{
              this.loggedinAvailable = true;
            }
            return requiredRoles.some((role: string) =>
              this.userType.includes(role)
            );
          });
        this.isLoading = false;
      },
      (error) => {
        console.error('Error fetching user roles:', error);
        this.isLoading = false;
      }
    );
  }
}
